import { createMeetingContext } from "common/meeting/context";
import type { MeetingAnalytics } from "common/meeting/notary/analytics";
import type {
  NotaryMeeting,
  NotaryMeetingVariables,
} from "common/meeting/notary/meeting_query.graphql";

const { useMeetingContext, MeetingContextProvider } = createMeetingContext<
  NotaryMeeting,
  NotaryMeetingVariables,
  MeetingAnalytics
>();

export const NotaryMeetingProvider = MeetingContextProvider;
export const useNotaryMeetingContext = useMeetingContext;
